(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const openBtn = document.querySelector(".header__offcanvas-toggle");
		const closeBtn = document.querySelector(
			".header__offcanvas-toggle-link--close",
		);
		const offMenu = document.querySelector(".header__offcanvas-menu");
		const searchDetails = document.querySelector(".header__details");
		const submenuDetails = document.querySelectorAll(
			".header__submenu li details",
		);
		const openSearchBtn = document.querySelector(".header__search");
		const openAccountBtn = document.querySelector(".header__icon--account");
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";
		const headerIsSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "on-scroll-up";
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
		const offcanvasTrap = {
			keydown: null,
			focusin: null,
			lastFocused: null,
		};

		const getFocusableElements = (container) => {
			return Array.from(
				container.querySelectorAll(
					"a[href], button:not([disabled]), textarea:not([disabled]), input:not([type='hidden']):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])",
				),
			).filter((element) => element.getAttribute("aria-hidden") !== "true");
		};

		const removeOffcanvasTrap = () => {
			if (offcanvasTrap.keydown) {
				document.removeEventListener("keydown", offcanvasTrap.keydown);
				offcanvasTrap.keydown = null;
			}
			if (offcanvasTrap.focusin) {
				document.removeEventListener("focusin", offcanvasTrap.focusin);
				offcanvasTrap.focusin = null;
			}
			if (offcanvasTrap.lastFocused && typeof offcanvasTrap.lastFocused.focus === "function") {
				offcanvasTrap.lastFocused.focus();
			}
			offcanvasTrap.lastFocused = null;
		};

		const applyOffcanvasTrap = () => {
			if (!offMenu) return;
			removeOffcanvasTrap();
			offcanvasTrap.lastFocused = document.activeElement;

			const focusableElements = getFocusableElements(offMenu);
			const firstFocusable = focusableElements[0] || offMenu;
			const lastFocusable =
				focusableElements[focusableElements.length - 1] || offMenu;

			if (!offMenu.hasAttribute("tabindex")) {
				offMenu.setAttribute("tabindex", "-1");
			}

			offcanvasTrap.keydown = (event) => {
				if (event.key !== "Tab") return;

				if (!focusableElements.length) {
					event.preventDefault();
					offMenu.focus();
					return;
				}

				const activeElement = document.activeElement;
				if (event.shiftKey) {
					if (activeElement === firstFocusable || activeElement === offMenu) {
						event.preventDefault();
						lastFocusable.focus();
					}
				} else if (activeElement === lastFocusable) {
					event.preventDefault();
					firstFocusable.focus();
				}
			};

			offcanvasTrap.focusin = (event) => {
				if (!offMenu.classList.contains("header__offcanvas-menu--open")) return;
				if (!offMenu.contains(event.target)) {
					firstFocusable.focus();
				}
			};

			document.addEventListener("keydown", offcanvasTrap.keydown);
			document.addEventListener("focusin", offcanvasTrap.focusin);

			setTimeout(() => {
				firstFocusable.focus();
			}, 0);
		};

		const openMenu = (e) => {
			e.preventDefault();
			offMenu.classList.add("header__offcanvas-menu--open");
			if (openBtn) openBtn.classList.add("active");
			applyOffcanvasTrap();
		};

		const closeMenu = () => {
			offMenu.classList.remove("header__offcanvas-menu--open");
			if (openBtn) openBtn.classList.remove("active");
			removeOffcanvasTrap();
		};

		if (openBtn) openBtn.addEventListener("click", openMenu);
		if (closeBtn)
			closeBtn.addEventListener("click", function (e) {
				e.preventDefault();
				closeMenu();
			});

		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener("click", () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute("open");
					}
				});
			});
		});

		document.addEventListener("keyup", (e) => {
			let scrollTop = window.scrollY;
			if (e.key === "Escape") {
				closeMenu();
				body.classList.remove("overflow-hidden");
				if (
					searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsSticky
				) {
					header.classList.remove(
						"animate",
						"animated",
						"shopify-section-header-sticky",
					);
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsAlwaysSticky
				) {
					header.classList.remove("animate", "animated");
					header.classList.add("shopify-section-header-sticky");
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					scrollTop > header.offsetHeight / 2 &&
					(headerIsSticky || headerIsAlwaysSticky)
				) {
					header.classList.add(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
					searchDetails.removeAttribute("open");
				} else if (
					searchDetails.open &&
					!headerIsAlwaysSticky &&
					!headerIsSticky
				) {
					header.classList.remove(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
					searchDetails.removeAttribute("open");
				}
			}
		});

		if (openSearchBtn) {
			openSearchBtn.addEventListener("click", () => {
				let scrollTop = window.scrollY;
				if (searchDetails.open && headerIsAlwaysSticky) {
					body.classList.add("overflow-hidden");
					header.classList.add(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
					);
				} else if (searchDetails.open && !headerIsAlwaysSticky) {
					body.classList.add("overflow-hidden");
					header.classList.add("shopify-section-header-sticky", "animate");
				} else if (
					!searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsSticky
				) {
					body.classList.remove("overflow-hidden");
					header.classList.remove(
						"animate",
						"animated",
						"shopify-section-header-sticky",
					);
				} else if (
					!searchDetails.open &&
					scrollTop < header.offsetHeight / 2 &&
					headerIsAlwaysSticky
				) {
					body.classList.remove("overflow-hidden");
					header.classList.remove("animate", "animated");
				} else if (
					!searchDetails.open &&
					scrollTop > header.offsetHeight / 2 &&
					(headerIsSticky || headerIsAlwaysSticky)
				) {
					body.classList.remove("overflow-hidden");
					header.classList.add(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
				} else if (
					!searchDetails.open &&
					!headerIsAlwaysSticky &&
					!headerIsSticky
				) {
					body.classList.remove("overflow-hidden");
					header.classList.remove(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
				} else {
					body.classList.remove("overflow-hidden");
					header.classList.remove(
						"shopify-section-header-sticky",
						"fixed",
						"animate",
						"animated",
					);
				}
			});
		}

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;

			if (scrollTop > header.offsetHeight / 2 && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		let scrollTop = window.scrollY;

		if (scrollTop > header.offsetHeight / 2 && headerIsAlwaysSticky) {
			header.classList.add("fixed", "animate");
		} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
			header.classList.remove("fixed", "animate");
		}

		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");

				link.addEventListener("mousemove", () => {
					link.classList.add("list-menu--megamenu-visible");
				});

				link.addEventListener("mouseleave", () => {
					setTimeout(() => {
						link.classList.remove("list-menu--megamenu-visible");
					}, 300);
					link.addEventListener("mouseenter", () => {
						link.classList.add("list-menu--megamenu-visible");
					});
				});
			});
		});
		
		if (openAccountBtn) {
			openAccountBtn.addEventListener("click", () => {
				openAccountBtn.setAttribute("aria-expanded", openAccountBtn.getAttribute("aria-expanded") === "true" ? "false" : "true");
			});
			openAccountBtn.addEventListener("focusout", () => {
				setTimeout(() => {
					if (openAccountBtn.contains(document.activeElement)) return;

					openAccountBtn.setAttribute("aria-expanded", "false");
					const accountDetails = openAccountBtn.parentElement.querySelector("details");
					if (accountDetails) {
						accountDetails.removeAttribute("open");
					}
				}, 0);
			});
		}
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();
